import React from "react";
import { getButtonClasses } from "../Inputs/inputUtility";
import { Link } from "./Link";

interface LinkButtonProps {
    describedby?: string;
    isExpanded?: boolean;
    isLarge?: boolean;
    isPrimary?: boolean;
    label?: React.ReactNode;
    to: string;
}

export const LinkButton: React.FC<LinkButtonProps> = ({ describedby, isExpanded, isLarge, isPrimary, label, to }: LinkButtonProps) => {
    const className = getButtonClasses({ isExpanded, isPrimary, isLarge });

    return <Link describedby={describedby} to={to} label={label} className={className}/>;
};

interface TertiaryLinkButtonProps {
    isExpanded?: boolean;
    isLarge?: boolean;
    label?: React.ReactNode;
    to: string;
}

export const TertiaryLinkButton: React.FC<TertiaryLinkButtonProps> = ({ isExpanded, isLarge, label, to }: TertiaryLinkButtonProps) => {
	const className = getButtonClasses({ isTertiary: true, isExpanded, isLarge });

	return <Link to={to} label={label} className={className}/>;
};
